/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { generateIteratorKey as keygen } from '../../../utils/helpers';

const MenuItem = ({ tcDownloadHandler, tcStyle, tcLabel }) => (
  <li {...keygen()} className={`${tcStyle}`} onClick={tcDownloadHandler}>
    {tcLabel}
  </li>
);

MenuItem.propTypes = {
  tcLabel: PropTypes.string,
  tcStyle: PropTypes.string,
  tcDownloadHandler: PropTypes.func
};

export default MenuItem;
